import styled from 'styled-components'

import Text from './Text'

/**
 * タイトルテキスト
 */
const TextTitle = styled(Text)`
  font-weight: bold;
  font-size: 24px;
  text-align: center;
`

export default TextTitle
